// extracted by mini-css-extract-plugin
module.exports = {"barGraph":"barGraph2-module--barGraph--3iLUz","group":"barGraph2-module--group--2pYOM","scaleAnim":"barGraph2-module--scaleAnim--1kp5M"};